import { useState, useEffect } from "react";
import axios from "axios";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { parseISO, format } from "date-fns";
import { Link } from "react-router-dom";
import { Row, Col, Button } from "react-bootstrap";

import { REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL } from "config";

const dateCellRenderer = (params) => {
  const date = format(parseISO(params.value), "dd/MM/yy HH:mm");
  return date;
};

const dateValueGetter = (params, key) => {
  if (!params.data[key]) {
    return "";
  }
  const date = format(parseISO(params.data[key]), "dd/MM/yy HH:mm");
  return date;
};

const editCellRenderer = (params) => {
  return <Link to={`/admin/groups/${params.data._id}`}>Edit</Link>;
};

const deleteCellRenderer = (params) => {
  return (
    <Button
      onClick={() => {
        if (!params.data.createdBy) {
          alert(
            "Can not delete default groups, screenshot and request from tech support"
          );
        } else {
          params.data.deleteGroup(params.data._id);
        }
      }}
    >
      Delete
    </Button>
  );
};

const brandCellRenderer = (params) => {
  if (!params.value) {
    return "All Brands";
  }
  return params.value;
};

const columns = [
  // {
  //   field: "_id",
  //   headerName: "_id",
  //   resizable: true,
  //   filter: "agTextColumnFilter",
  // },
  // {
  //   field: "createdAt",
  //   headerName: "Created On",
  //   resizable: true,
  //   filter: "agTextColumnFilter",
  //   cellRendererFramework: dateCellRenderer,
  //   filterParams: {
  //     valueGetter: (params) => {
  //       return dateValueGetter(params, "createdAt");
  //     },
  //   },
  // },
  {
    field: "slug",
    resizable: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "level",
    resizable: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "name",
    resizable: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "forCategory",
    headerName: "Category",
    resizable: true,
    filter: "agTextColumnFilter",
  },
  {
    field: "forBrandBCId",
    headerName: "Brand",
    resizable: true,
    filter: "agTextColumnFilter",
    cellRendererFramework: brandCellRenderer,
  },
  {
    field: "edit",
    headerName: "Edit",
    resizable: true,
    filter: "agTextColumnFilter",
    cellRendererFramework: editCellRenderer,
  },
  {
    field: "delete",
    headerName: "Delete",
    resizable: true,
    filter: "agTextColumnFilter",
    cellClass: "action",
    minWidth: 120,
    cellRendererFramework: deleteCellRenderer,
  },
];

function Groups() {
  const [groups, setGroups] = useState([]);
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    getAndSetGroups(); // eslint-disable-next-line react-hooks/exhaustive-deps
    getAndSetBrands();
  }, []);

  useEffect(() => {
    if (brands.length > 0) {
      getAndSetGroups();
    }
  }, [brands]);

  const getAndSetBrands = async () => {
    try {
      const response = await axios.get(
        `${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/admin/bc/brands`
      );
      if (response.status === 200) {
        setBrands(response.data?.brands || []);
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const deleteGroup = async (groupId) => {
    const update = { status: "deleted" };
    try {
      const response = await axios.delete(
        `${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/admin/groups/${groupId}`
      );
      if (response.status === 200) {
        window.location.reload(true);
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const getAndSetGroups = async () => {
    try {
      const response = await axios.get(
        `${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/admin/groups`
      );
      if (response.status === 200) {
        const groups = response.data.groups;
        for (const group of groups) {
          group.deleteGroup = deleteGroup;
          // Add brand name to the group data for display
          if (group.forBrandBCId) {
            const brand = brands.find(
              (b) => b.id.toString() === group.forBrandBCId.toString()
            );
            group.forBrandBCId = brand ? brand.name : group.forBrandBCId;
          }
        }
        setGroups(groups);
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  const onGridReady = (params) => {
    params.api.sizeColumnsToFit();
  };

  return (
    <div style={{ padding: "40px" }}>
      <Row>
        <Col xs={{ span: 6 }}>
          <h1 style={{ marginBottom: "30px" }}>Groups</h1>
        </Col>
        <Col xs={{ span: 2, offset: 4 }}>
          <Link to={"/admin/groups/new"}>
            <Button>Create new group</Button>
          </Link>
        </Col>
      </Row>
      <div
        className="ag-theme-alpine"
        style={{
          height: "500px",
          width: "100%",
        }}
      >
        <AgGridReact
          defaultColDef={{
            filter: true,
            minWidth: 170,
          }}
          floatingFilter={true}
          columnDefs={columns}
          rowData={groups}
          onGridReady={onGridReady}
          rowHeight={42}
        />
      </div>
    </div>
  );
}
export default Groups;
